import { IconProps } from '../Icons.type'

export function CloseIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.854 2.14598C13.9006 2.19242 13.9375 2.2476 13.9627 2.30834C13.9879 2.36909 14.0009 2.43421 14.0009 2.49998C14.0009 2.56575 13.9879 2.63087 13.9627 2.69161C13.9375 2.75236 13.9006 2.80753 13.854 2.85398L2.85402 13.854C2.76013 13.9479 2.6328 14.0006 2.50002 14.0006C2.36725 14.0006 2.23991 13.9479 2.14602 13.854C2.05213 13.7601 1.99939 13.6328 1.99939 13.5C1.99939 13.3672 2.05213 13.2399 2.14602 13.146L13.146 2.14598C13.1925 2.09941 13.2476 2.06247 13.3084 2.03727C13.3691 2.01206 13.4343 1.99908 13.5 1.99908C13.5658 1.99908 13.6309 2.01206 13.6917 2.03727C13.7524 2.06247 13.8076 2.09941 13.854 2.14598Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.14604 2.14598C2.09948 2.19242 2.06253 2.2476 2.03733 2.30834C2.01212 2.36909 1.99915 2.43421 1.99915 2.49998C1.99915 2.56575 2.01212 2.63087 2.03733 2.69161C2.06253 2.75236 2.09948 2.80753 2.14604 2.85398L13.146 13.854C13.2399 13.9479 13.3673 14.0006 13.5 14.0006C13.6328 14.0006 13.7602 13.9479 13.854 13.854C13.9479 13.7601 14.0007 13.6328 14.0007 13.5C14.0007 13.3672 13.9479 13.2399 13.854 13.146L2.85404 2.14598C2.80759 2.09941 2.75242 2.06247 2.69167 2.03727C2.63093 2.01206 2.56581 1.99908 2.50004 1.99908C2.43427 1.99908 2.36915 2.01206 2.30841 2.03727C2.24766 2.06247 2.19248 2.09941 2.14604 2.14598Z"
        fill="currentColor"
      />
    </svg>
  )
}
